import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 20, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, ease: easing, delay }}
  >
    {children}
  </motion.div>
);

export const staggerContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 18 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: easing },
  },
};

export const Overline = ({ children, className = "" }) => (
  <span
    className={`font-mono-tech text-xs tracking-[0.25em] uppercase text-tertiary-c ${className}`}
  >
    {children}
  </span>
);

export const SectionHeading = ({ index, overline, title, description }) => (
  <div className="mb-14 md:mb-20 max-w-3xl">
    <div className="flex items-center gap-3 mb-5">
      <span className="font-mono-tech text-xs tracking-[0.25em] text-tertiary-c">
        {index}
      </span>
      <span className="h-px w-8 bg-[var(--border-strong)]" />
      <Overline>{overline}</Overline>
    </div>
    <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight text-primary-c leading-[1.05]">
      {title}
    </h2>
    {description && (
      <p className="mt-5 text-base md:text-lg text-secondary-c leading-relaxed">
        {description}
      </p>
    )}
  </div>
);
